import { Crown, X } from "lucide-react";

/**
 * Strike 2 — shown when a non-admin tries to create an Agency Workspace.
 * The backend hard-blocks creation with 403; this is the friendly UI gate.
 */
export default function EnterpriseLockModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      data-testid="enterprise-lock-modal"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md bg-[#0d0d0d] border border-[#27272a] rounded-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2 text-amber-300">
            <Crown className="w-5 h-5" strokeWidth={1.8} />
            <span className="text-xs font-mono uppercase tracking-[0.2em]">
              Enterprise feature
            </span>
          </div>
          <button
            onClick={onClose}
            data-testid="enterprise-lock-close"
            className="text-neutral-500 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" strokeWidth={1.8} />
          </button>
        </div>
        <h2 className="font-display text-2xl font-semibold mt-4">
          Agency Workspaces
        </h2>
        <p className="text-sm text-neutral-400 mt-2 leading-relaxed">
          Multi-workspace sub-accounts let agencies isolate clients, branding,
          and inboxes under a single login. This is an Enterprise capability.
        </p>
        <div className="mt-5 border border-[#1f1f1f] bg-[#0a0a0a] rounded-lg p-4">
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500">
            To unlock, contact
          </div>
          <a
            href="mailto:yasen@coreflowconsulting.com"
            data-testid="enterprise-contact-email"
            className="text-amber-300 hover:text-amber-200 font-mono text-sm mt-1 inline-block"
          >
            yasen@coreflowconsulting.com
          </a>
        </div>
        <button
          onClick={onClose}
          className="mt-5 w-full bg-white text-black rounded-md py-2 text-sm font-medium hover:bg-neutral-200 transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
